import { accountDetails } from "@di";
import DpInterestRepository from "@adapters/repositories/Reports/DpInterestReport";
export default (http) => {
    return {
        DpInterest: new DpInterestRepository(http, accountDetails),
    };
};
